import PractitionerProfileI, { IPractitionerProfile } from "@interfaces/practitioner-profileI";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IPractitionerProfileSlice
{
    /**
     * @deprecated
     */
    profile: PractitionerProfileI,
    practitionerProfile?: IPractitionerProfile
}

const initialState = {
    profile: {},
    practitionerProfile: undefined
} as IPractitionerProfileSlice

export const practitionerProfileSlice = createSlice({
    name: "practitioner-profile",
    initialState: initialState,
    reducers: {
        /**
         * @deprecated 
         */
        setProfile: (state, action: PayloadAction<PractitionerProfileI>) => {
            state.profile = action.payload;
        },
        setPractitionerProfile: (state, action: PayloadAction<IPractitionerProfile>) => {
            state.practitionerProfile = action.payload
        },
        cleanProfile: (state) => {
            state = initialState
        }
    },
});

export const { setProfile, setPractitionerProfile, cleanProfile } = practitionerProfileSlice.actions;
export default practitionerProfileSlice.reducer;
